export default __webpack_public_path__ + "static/media/charged.f7d86848.svg";